import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./GallerySection.css";

const GallerySection = ({ images }) => (
  <>
    <div className="home-section-divider fade-in-up">
      <hr className="home-divider-line" />
      <h4 className="home-divider-text">Explore Our New Items</h4>
      <hr className="home-divider-line" />
    </div>
      <h3 className="home-signature-text">Signature Gift Boxes</h3>
    <div className="home-gallery-container fade-in-up">
      <Swiper
        slidesPerView={4}
        spaceBetween={10}
        breakpoints={{
          320: { slidesPerView: 2 },
          480: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        loop={true}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        modules={[Autoplay]}
      >
        {images.map((img, idx) => (
          <SwiperSlide key={idx} className="home-gallery-slide">
            <div className="home-gallery-card">
              <img src={img.image} alt={`Gallery ${idx}`} className="home-gallery-image" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </>
);

export default GallerySection;